import { atom } from "recoil";

const activeNavItemState = atom({
  key: "activeNavItemState",
  default: 0,
});

export { activeNavItemState };
